import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-ops" }
const _hoisted_2 = { class: "text-sm dark:text-custom-blue-50" }

import usePoolCreation from '@/composables/pools/usePoolCreation';
import useNumbers, { FNumFormats } from '@/composables/useNumbers';
import useTokens from '@/composables/useTokens';

import { Pool } from '@/services/balancer/subgraph/types';

/**
 * COMPOSABLES
 */

export default _defineComponent({
  setup(__props) {

const { similarPools } = usePoolCreation();
const { tokens } = useTokens();
const { fNum2 } = useNumbers();
/**
 * FUNCTIONS
 */
function getPoolLabel(pool: Pool) {
  const tokensString = pool.tokens
    .map(
      t =>
        `${tokens.value[t.address]?.symbol} ${fNum2(
          t.weight,
          FNumFormats.percent
        )}`
    )
    .join(', ');
  return `${tokensString} (${fNum2(pool.swapFee, FNumFormats.percent)} fee)`;
}

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalStack = _resolveComponent("BalStack")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    noPad: "",
    shadow: "none"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BalStack, {
        spacing: "sm",
        align: "center",
        horizontal: "",
        class: "p-2 px-3 border-b dark:border-custom-black-300 text-custom-yellow-50"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BalIcon, {
            name: "alert-circle",
            size: "md"
          }),
          _createElementVNode("h6", _hoisted_1, _toDisplayString(_ctx.$t('createAPool.similarPoolsExist')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_BalStack, {
        vertical: "",
        spacing: "sm",
        class: "p-4"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(similarPools), (pool) => {
            return (_openBlock(), _createBlock(_component_BalLink, {
              target: "_blank",
              href: `/#/pool/${pool.id}`,
              key: `similarpool-${pool.id}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(getPoolLabel(pool)), 1)
              ]),
              _: 2
            }, 1032, ["href"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})